export default "__VITE_ASSET__153ca629__"